:host {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 340px;
}

.text {
    text-align: center;
    min-height: 125px;
}

::slotted([slot='illustration']) {
    height: 150px;
    width: 150px;
    margin-bottom: 25px;
}

.body {
    font-size: 16px;
    font-weight: 300;
    text-align: center;
    margin: 0;
    margin-bottom: 36px;
}

::slotted([slot='foot']) {
    min-width: 220px;
}

:host(.horizontal) {
    & .inner {
        flex-direction: row;
        min-height: 170px;
    }

    & .text {
        text-align: left;
        min-height: unset;
    }

    & es-page-title {
        margin-bottom: 8px;
    }

    & .body {
        margin-bottom: 0;
    }

    & ::slotted([slot='illustration']) {
        height: 100px;
        width: 100px;
        margin-right: 25px;
        margin-bottom: 0;
    }
}
